export const ACCEPT_ALL_COOKIES = "ACCEPT_ALL_COOKIES";
